import { FIELD_SIZE, INPUT_FIELD_TYPE, INPUT_TYPE } from '@components/DynamicFormField/constant';
import { reviewFulfillmentProvider } from '@store/actions/ordersActions';


export const STATUS_TYPE_CONFIG = [
  {
    key: 'VERIFIED',
    value: 'VERIFIED',
    label: 'VERIFIED',
    isDisabled: false
  },
  {
    key: 'REJECTED',
    value: 'REJECTED',
    label: 'REJECTED',
    isDisabled: false
  }
];

const getReviewFieldsGroupedByProvider = (providers) => {
  const providerFieldsMap = {};

  providers?.forEach((provider) => {
    providerFieldsMap[provider] = [
      {
        key: "provider",
        name: "provider",
        value: provider,
        label: "Provider",
        caption: null,
        placeholder: "Enter Provider Name",
        fieldType: INPUT_FIELD_TYPE.INPUT,
        inputType: INPUT_TYPE.STRING,
        fieldSize: FIELD_SIZE.MEDIUM,
        width: "auto",
        isEditable: false,
        isRequired: false,
      },
      {
        key: "status",
        name: "status",
        value: null,
        label: "Status Type",
        caption: null,
        fieldType: INPUT_FIELD_TYPE.SELECT,
        fieldSize: FIELD_SIZE.MEDIUM,
        placeholder: "Select a Status",
        options: STATUS_TYPE_CONFIG?.map((option) => ({
          value: option.value,
          key: option.key,
          label: option.label,
          isDisabled: option.isDisabled,
        })),
        isEditable: true,
        isRequired: true,
      },
      {
        key: "remarks",
        name: "remarks",
        value: null,
        label: "Review",
        caption: null,
        placeholder: "Enter your review",
        fieldType: INPUT_FIELD_TYPE.INPUT,
        inputType: INPUT_TYPE.STRING,
        fieldSize: FIELD_SIZE.MEDIUM,
        width: "auto",
        isEditable: true,
        isRequired: true,
      },
    ];
  });

  return providerFieldsMap;
};

export const providersToReviewConfig = {
  id: 'providersToReviewConfig',
  providersToReviewFieldsConfig: (providersToReview) => getReviewFieldsGroupedByProvider(providersToReview),
  reviewFulfillmentProvider: ({ fulfillmentId, payload, onSuccess, onComplete}) => reviewFulfillmentProvider({
    fulfillmentId,
    payload,
    onSuccess,
    onComplete
  }),
}